<template>
  <MenuItem v-slot="{ active }">
    <Button
      v-bind="button"
      color="gray"
      variant="link"
      :ui="{ base: `w-full group px-3 py-2 text-sm font-medium justify-between ${active ? 'bg-gray-50' : ''}`, prepend: 'w-3.5 text-center' }"
    >
      <slot />
    </Button>
  </MenuItem>
</template>

<script setup lang="ts">
import { MenuItem } from '@headlessui/vue'

defineProps<{
  button?: ButtonProps
}>()
</script>
